export default __webpack_public_path__ + "static/revops 1-966a4b392db46408aa430016bc4a6ba4.png";